import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Remark.scss';
function Remark(p) {
    const showScore = () => {
        if (!p.score)
            return false;
        if (p.displayScore === 'yes') {
            return true;
        }
        else if (p.displayScore === 'no')
            return false;
        else if (p.displayScore === "auto") {
            return Number(p.score) >= 4;
        }
        return false;
    };
    const removeQuotes = (str) => {
        if (str.charAt(0) === '“' && str.charAt(str.length - 1) === '”') {
            return str.slice(1, -1);
        }
        return str;
    };
    return <View x-if={showScore() || p.soldInfo} className="remark-container">
      {showScore() && <View className="remark-score-container">
        <Text className="remark-score">{p.score}</Text>
      </View>}
      {p.recommendReason ? <View className="remark-avgScoreDesc">
          <Text className="remark-avgScoreDesc-text" numberOfLines={1}>{`"${removeQuotes(p.recommendReason)}"`}</Text>
        </View> : null}
      {p.soldInfo && <Text className="remark-number">已售{p.soldInfo}</Text>}
    </View>;
}
export default memo(Remark);
